import { render, staticRenderFns } from "./EditGroupTournament.vue?vue&type=template&id=5d2f8628&scoped=true"
import script from "./EditGroupTournament.vue?vue&type=script&lang=js"
export * from "./EditGroupTournament.vue?vue&type=script&lang=js"
import style0 from "./EditGroupTournament.vue?vue&type=style&index=0&id=5d2f8628&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2f8628",
  null
  
)

export default component.exports